/**
 * Sidebar model and constants for AZ Symphony app shell navigation.
 * Defines the nine-stage workflow structure used by SidebarComponent.
 */

/**
 * Represents a single stage item in the workflow navigation.
 */
export interface StageItem {
  /** Display name of the stage (e.g. "Requirements Intake") */
  name: string;
  /** Material Symbols Outlined ligature name for the stage icon (e.g. "description") */
  icon: string;
}

/**
 * Hard-coded constant array of all nine workflow stages.
 * Used by SidebarComponent to render navigation items and by AppShellComponent
 * to derive the active page title via computed signal.
 *
 * Order is significant and must match the spec (§8.2).
 * Each stage has a Material Symbols Outlined icon ligature name.
 */
export const STAGES: readonly StageItem[] = [
  { name: 'Requirements Intake', icon: 'description' },
  { name: 'Project Classification', icon: 'category' },
  { name: 'Backlog Review', icon: 'checklist' },
  { name: 'UI Feedback', icon: 'rate_review' },
  { name: 'Architecture', icon: 'account_tree' },
  { name: 'Agentified Build', icon: 'smart_toy' },
  { name: 'Quality Control', icon: 'verified' },
  { name: 'Costs and Budget', icon: 'payments' },
  { name: 'Deploy', icon: 'rocket_launch' },
];
